var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanhias(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.052,
    height: 26.002,
    viewBox: "0 0 32.052 26.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-store-alt",
    "data-name": "Icon awesome-store-alt",
    d: "M15,18H6V12.1H3V22.5A1.5,1.5,0,0,0,4.5,24h12A1.5,1.5,0,0,0,18,22.5V12.1H15ZM29.751,6.666l-4-6A1.508,1.508,0,0,0,24.5,0H5.5A1.494,1.494,0,0,0,4.258.666l-4,6A1.5,1.5,0,0,0,1.506,9h27A1.5,1.5,0,0,0,29.751,6.666ZM24,23.252a.752.752,0,0,0,.75.75h1.5a.752.752,0,0,0,.75-.75V12.1H24Z",
    transform: "translate(1.023 1)",
    fill: "none",
    stroke: "#f8f9fa",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanhias);
export default __webpack_public_path__ + "static/media/companhias.e214dddbe9364360bec796ece9f07f94.svg";
export { ForwardRef as ReactComponent };